const ToolbarMapModule = {
    _toolbarModel: {
        $undoControl: undefined,
        $resetControl: undefined,
        $backToHome: undefined,
        $snapToRoads: undefined,
        // $routeType: undefined
    },

    initializeToolbar() {
        this._toolbarModel.$undoControl = this._model.$mapId.querySelectorAll('.undo-control');
        this._toolbarModel.$resetControl = this._model.$mapId.querySelectorAll('.clear-control');
        this._toolbarModel.$backToHome = this._model.$mapId.querySelectorAll('.back-to-home');
        this._toolbarModel.$snapToRoads = this._model.$mapId.querySelectorAll('.snap-to-roads');
        // this._toolbarModel.$routeType = this._model.$mapId.querySelector('#route-type');
    },

    activateToolbarButtons() {
        if (this._toolbarModel.$undoControl) {
            Array.from(this._toolbarModel.$undoControl).map((el) => el.classList.remove('disabled'));
        }
        if (this._toolbarModel.$resetControl) {
            Array.from(this._toolbarModel.$resetControl).map((el) => el.classList.remove('disabled'));
        }
        if (this._toolbarModel.$backToHome) {
            Array.from(this._toolbarModel.$backToHome).map((el) => el.classList.remove('disabled'));
        }
    },

    activateBackToHome() {
        Array.from(this._toolbarModel.$backToHome).map((el) => el.classList.remove('disabled'));
    },

    disableToolbarButtons() {
        if (this._toolbarModel.$undoControl) {
            Array.from(this._toolbarModel.$undoControl).map((el) => el.classList.add('disabled'));
        }
        if (this._toolbarModel.$resetControl) {
            Array.from(this._toolbarModel.$resetControl).map((el) => el.classList.add('disabled'));
        }
        if (this._toolbarModel.$backToHome) {
            Array.from(this._toolbarModel.$backToHome).map((el) => el.classList.add('disabled'));
        }
    },

    disableSnapToRoad() {
        Array.from(this._toolbarModel.$snapToRoads).map((el) => el.checked = false);
    },

    disableBackToHome() {
        Array.from(this._toolbarModel.$backToHome).map((el) => el.classList.add('disabled'));
    },

    /* Private Methods
    ******************** */
};

export default ToolbarMapModule;
